import { helpers } 		from './sites/helpers.js';
import { example } 		from './sites/components/exapmple.js';
import { form_toggle } 		from './sites/components/form_toggle.js';

window.sites = {
	globals: {},

	init: function () {
		var self = this;

		example.init();
		form_toggle.init();
	},

	onresize() {
		var self = this;
	},

	onscroll(position, previusPosition) {
		var self = this;
	},
};

jQuery(document).ready(function ($) {
	sites.init();

	var inputs = document.querySelectorAll('.order_field');
	function checkContent() {
		
		// Loop through each input element in the NodeList
		inputs.forEach(function(input) {
			console.log('test', input);
			// Function to update class based on content
			function updateClass() {
				if (input.value.trim() !== '') {
					input.classList.add('has-content');
				} else {
					input.classList.remove('has-content');
				}
			}
			// Add event listeners for input changes
			input.addEventListener('input', updateClass);
			input.addEventListener('blur', updateClass);
			input.addEventListener('focus', updateClass);
	
			// Initial check
			updateClass();
		});
	}
	checkContent();
});

window.addEventListener('scroll', function (e) {
	sites.onscroll();
});

window.addEventListener('resize', function (e) {
	sites.onresize();
});